import { create } from "zustand";
import { CUSTOMER_STORAGE_BASE_FOLDER_URL } from "@features/CustomerStorage/constants";
import type { ICustomerStorageItemAction } from "@services/customerStorage/types";

interface IUseCustomerStorageStoreProps {
  currentFolderUrl: string;
  searchQuery: string;
  documentViewerAction?: ICustomerStorageItemAction;
  setCurrentFolderUrl: (currentFolderUrl: string) => void;
  setSearchQuery: (searchQuery: string) => void;
  setDocumentViewerAction: (action: ICustomerStorageItemAction) => void;
  clearDocumentViewerAction: () => void;
}

export const useCustomerStorageStore = create<IUseCustomerStorageStoreProps>(
  (set) => ({
    currentFolderUrl: CUSTOMER_STORAGE_BASE_FOLDER_URL,
    setCurrentFolderUrl: (currentFolderUrl) => set({ currentFolderUrl }),
    searchQuery: "",
    setSearchQuery: (searchQuery) => set({ searchQuery }),
    documentViewerAction: undefined,
    setDocumentViewerAction: (action) => set({ documentViewerAction: action }),
    clearDocumentViewerAction: () => set({ documentViewerAction: undefined }),
  }),
);
